import { useEffect, useState } from "react"

import classes from './RadioFieldCustom.module.css'
import RadioButtonCustom from "./RadioButtonCustom"



const RadioFieldCustom = ({fields, legend, name, defaultChecked, identifier, action, normalSize}) => {
    const [isChecked, setIsChecked] = useState(null)

    const changeHandler = (event) => {
        setIsChecked(event.target.value)

        if (action) {
            action({
                value: event.target.value,
                identifier: identifier
            })
        }
    }


    useEffect(() => {
        setIsChecked(defaultChecked)
    }, [defaultChecked])


    return <>
        {fields && <div className={`${classes.container} ${normalSize ? classes.normal_size : ''}`}>
            {fields.map(item => (
                <RadioButtonCustom key={item.price_quote_id + item.ride_type} item={item} checked={item.price_quote_id ? item.price_quote_id == isChecked : false} changeHandler={changeHandler} name={name + identifier.type}/>
            ))}    
        </div>}
    </>
}

export default RadioFieldCustom